function getPriceWithDiscountAndPromotions({ priceWithDiscount }) {
  return typeof priceWithDiscount === 'function'
    ? priceWithDiscount()
    : priceWithDiscount;
}

export default getPriceWithDiscountAndPromotions;
